import { ResultStream } from '@causality/core';
import { SupporterFeedbackForm } from '@formunauts/supporter-feedback/domain';
import {
  SupporterFeedbackFormRepository,
  SupporterFeedbackFormSaveError,
} from './supporter-feedback-data-access.model';

export const save =
  (repo: SupporterFeedbackFormRepository) =>
  (
    request: SupporterFeedbackForm.SaveRequest,
  ): ResultStream.ResultStream<
    SupporterFeedbackForm.SummaryForm,
    SupporterFeedbackFormSaveError
  > =>
    repo.save(request);
